import React from 'react';
import { View, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useClock } from '@shared/hooks/useClock';
import { useBatteryStatus } from '@shared/hooks/useBatteryStatus';
import { BatteryIndicator } from './BatteryIndicator';

export const GlobalStatusHeader: React.FC = () => {
  const insets = useSafeAreaInsets();
  const time = useClock();
  const battery = useBatteryStatus();

  return (
    <View
      className="bg-white"
      style={{ paddingTop: insets.top, paddingLeft: insets.left, paddingRight: insets.right }}
    >
      <View className="h-[40px] flex-row items-center justify-between px-lg">
        <Text className="text-[24px] font-bold text-black">{time}</Text>
        <BatteryIndicator {...battery} />
      </View>
    </View>
  );
};
